import { render } from "./HeaderComponent.vue?vue&type=template&id=a0347e1e&scoped=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"

import "./HeaderComponent.vue?vue&type=style&index=0&id=a0347e1e&lang=css"
import "./HeaderComponent.vue?vue&type=style&index=1&id=a0347e1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0347e1e"]])

export default __exports__